<template>
  <div>
    <nav-app ref="nav"></nav-app>
    <div style="min-height: calc(100vh - 81px - 108px)">
      <slot></slot>
    </div>
    <footer-app ref="footer"></footer-app>
  </div>
</template>

<script>
import NavApp from "@/components/Nav/navApp";
import FooterApp from "@/components/Nav/footerApp";

export default {
  name      : "MainLayout",
  components: {NavApp, FooterApp}
}
</script>

<style scoped>

</style>